var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.resultPayment.success)?_c('p',[_vm._v("\n    "+_vm._s(_vm.resultPayment.item)+"\n  ")]):_c('p',[_vm._v("\n    "+_vm._s(_vm.resultPayment.error.message)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ba9b5f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaymentStatus.vue
// module id = null
// module chunks = 